import { QueryUsersArgs } from '../graphql/schema';

import { useStore } from '../composables/store.composable';

import UserDataPrefillService from './user-data-prefill.service';

export default class CiamService {
  static async getCiamId(): Promise<string> {
    const {
      dispatch,
      state: { otbcUser: token },
    } = useStore();

    const variables: QueryUsersArgs = {
      token: token.token,
    };

    const data = await dispatch('getCiamId', variables);
    return data;
  }

  static async getCiamIdByEmailAndBuildProspect(payload: string): Promise<any> {
    const { dispatch } = useStore();
    const prospect = await dispatch(
      'getCiamIdByEmailAndBuildProspect',
      payload
    );

    return prospect;
  }

  static async handleLoggedInStatus(formConfig: any): Promise<void> {
    const { commit, state } = useStore();

    if (state?.otbcUser?.token) {
      const ciamId = await CiamService.getCiamId();

      const wkoUserData = state?.otbcUser?.wkoUserData;
      const wkoUser =
        wkoUserData && typeof wkoUserData === 'string'
          ? JSON.parse(wkoUserData)
          : wkoUserData;
      const prospect = UserDataPrefillService.parseMMeUser(
        wkoUser,
        ciamId,
        formConfig
      );

      commit('prospect', prospect);
    }
  }
}
